export const initialAccessListState = {
  owner: null,
  internalUsers: [],
  userGroups: [],
  organization: null,
  externalUsers: [],
  pendingInvites: [],
  isLoading: false,
  isFetched: false,
  isError: false,
}

export const emptyPendingPermissions = {
  users: {},
  userGroups: {},
  organization: undefined,
  userEmails: {},
}

export const emptyPendingRecipients = []
